import React from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { useInviteModalStyles } from '../../../src/friends/contexts/InviteModalStylesContext';

interface ManualEmailItemProps {
  email: string;
  isSelected: boolean;
  onToggle: () => void;
  onRemove: () => void;
  testID?: string;
}

export const ManualEmailItem: React.FC<ManualEmailItemProps> = ({
  email,
  isSelected,
  onToggle,
  onRemove,
  testID,
}) => {
  const styles = useInviteModalStyles();
  return (
    <Pressable
      onPress={isSelected ? () => onRemove() : onToggle}
      style={({ pressed, hovered }) => [
        styles.contactItem,
        isSelected && styles.contactItemSelected,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.contactItemPressed,
        hovered && Platform.OS === 'web' && styles.contactItemHover,
      ]}
      testID={testID || `manual-email-item-${email}`}
    >
      <View style={styles.contactAvatar}>
        <Text style={styles.contactAvatarText}>@</Text>
      </View>
      <View style={styles.contactInfo}>
        <Text style={styles.contactName}>{email}</Text>
        <Text style={styles.manualEmailLabel}>Manual entry</Text>
      </View>
      {isSelected && (
        <Pressable
          onPress={(e) => { e?.stopPropagation?.(); onRemove(); }}
          style={({ pressed, hovered }) => [
            styles.removeButton,
            Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
            pressed && styles.removeButtonPressed,
            hovered && Platform.OS === 'web' && styles.removeButtonHover,
          ]}
        >
          <Text style={styles.removeButtonText}>×</Text>
        </Pressable>
      )}
    </Pressable>
  );
};

